import { GROUPS } from '~/common/helpers';
import { IUserForm } from '~/connect/types';

type UserFormField = 'entities' | 'groups' | 'email' | 'locale';
type UserFormPrivileges = {
  fields: {
    [FieldKey in UserFormField]: {
      visible: boolean;
      writable: boolean;
    };
  };
  actions: {
    RESET_PASSWORD: {
      visible: boolean;
    };
  };
};
type Args = {
  values: Pick<IUserForm, 'groups'>;
  wyzAccount?: boolean;
  mode: 'CREATE' | 'UPDATE' | 'DETAIL';
};
export const useUserFormPrivileges = ({
  values,
  wyzAccount,
  mode,
}: Args): UserFormPrivileges => {
  const hasGroupPlatformAdmin = values.groups.includes(
    GROUPS.GROUP_PLATFORM_ADMIN,
  );
  return {
    actions: {
      RESET_PASSWORD: {
        visible: !wyzAccount && mode === 'UPDATE',
      },
    },
    fields: {
      entities: {
        visible: !hasGroupPlatformAdmin && !wyzAccount,
        writable: !hasGroupPlatformAdmin && !wyzAccount,
      },
      groups: {
        visible: !wyzAccount,
        writable: !hasGroupPlatformAdmin && !wyzAccount,
      },
      email: {
        visible: !wyzAccount,
        writable: !wyzAccount,
      },
      locale: {
        visible: !wyzAccount,
        writable: !wyzAccount,
      },
    },
  };
};
